// extracted by mini-css-extract-plugin
module.exports = {"material-picker-container":"LeftRail_material-picker-container__MKvPp","bottom-content":"LeftRail_bottom-content__jYGAU","container":"LeftRail_container__Evc2C"};